import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import './text-box-group.scss';
import { getDigitsOnly, getNumberWithDot } from '../../helpers/utils';

const TextBoxWithGroup = forwardRef(
  (
    {
      id,
      label,
      errorMessage,
      required,
      message,
      className,
      placement,
      type,
      children,
      classNamesgroupwrapper,
      ...otherProps
    },
    ref
  ) => {
    const internalRef = useRef(null);

    // Merge external ref and internal ref
    useImperativeHandle(ref, () => ({
      focus: () => {
        internalRef.current?.focus();
      },
      clear: () => {
        if (internalRef.current) internalRef.current.value = '';
      },
      get value() {
        return internalRef.current?.value;
      },
    }));

    return (
      <div
        className={`text-box-group-container ${className} ${
          errorMessage ? 'error' : ''
        }`}
      >
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span className="required">*</span>}
          </label>
        )}
        <div
          className={`text-box-group-wrapper ${placement} ${classNamesgroupwrapper}`}
        >
          <input
            id={id}
            ref={internalRef}
            onKeyDown={(e) => {
              if (type === 'number') {
                if (id === 'quantity') {
                  getDigitsOnly(e);
                } else {
                  getNumberWithDot({ e, decimalLimit: 3 });
                }
              }
              if (e.key === 'Tab') {
                internalRef.current?.blur();
              }
            }}
            {...otherProps}
          />
          <span className="extra-field">{children}</span>
        </div>

        {message !== '' && <p className="message">{message}</p>}
        {errorMessage !== '' && <p className="error-message">{errorMessage}</p>}
      </div>
    );
  }
);

TextBoxWithGroup.displayName = 'TextBoxWithGroup';

TextBoxWithGroup.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  message: PropTypes.string,
  mBottom: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  placement: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  classNamesgroupwrapper: PropTypes.string,
};

TextBoxWithGroup.defaultProps = {
  label: '',
  id: '',
  errorMessage: '',
  required: false,
  message: '',
  mBottom: '',
  size: '',
  width: '',
  className: '',
  placement: '',
  type: 'text',
  children: {},
  classNamesgroupwrapper: '',
};

export default TextBoxWithGroup;
